
        var result = require("!!../../../../node_modules/css-loader/index.js!./price-change-percentage.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/price-change-percentage.component.css
// module id = 2361
// module chunks = 1